// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Wm3M7"};